import React from 'react'
import PropTypes from 'prop-types'
import QuickLinks from 'components/shared/QuickLinks'
import { DollarOutlined, FundOutlined } from '@ant-design/icons'
import { Row, Col } from 'antd'

export default function OtherBrokersList({
  allBrokers,
  currentBroker,
  country,
}) {
  const fullServiceLinkList = []
  const discountLinkList = []
  const brokers = []
  allBrokers.forEach((broker) => {
    const {
      attributes: { name, slug, broker_type },
    } = broker

    if (broker.attributes.country.name === country.name) {
      brokers.push({
        href: '/broker/[slug]',
        as: `/broker/${slug}`,
        linkText: ` ${name} Review`,
      })
    }

    if (slug === currentBroker.slug) {
      return true
    }
    if (broker_type === 'full_service') {
      fullServiceLinkList.push({
        href: '/broker/[slug]',
        as: `/broker/${slug}`,
        linkText: ` ${name} Review`,
      })
    }
    if (broker_type === 'discount') {
      discountLinkList.push({
        href: '/broker/[slug]',
        as: `/broker/${slug}`,
        linkText: ` ${name} Review`,
      })
    }

    return true
  })
  if (country.name === 'India')
    return (
      <>
        <Row style={{ marginBottom: '16px' }}>
          <Col span={24}>
            <QuickLinks
              title="Discount Brokers"
              linkList={discountLinkList}
              icon={<FundOutlined />}
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: '16px' }}>
          <Col span={24}>
            <QuickLinks
              title="Full Service Brokers"
              linkList={fullServiceLinkList}
              icon={<DollarOutlined />}
            />
          </Col>
        </Row>
      </>
    )
  return (
    <Row style={{ marginBottom: '16px' }}>
      <Col span={24}>
        <QuickLinks
          title="All Brokers"
          linkList={brokers}
          icon={<FundOutlined />}
        />
      </Col>
    </Row>
  )
}

OtherBrokersList.propTypes = {
  allBrokers: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      broker_type: PropTypes.string,
    }).isRequired
  ).isRequired,
  currentBroker: PropTypes.shape({
    slug: PropTypes.string.isRequired,
  }).isRequired,
  country: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
}
